<template>
    <div>
        <div v-if="['article', 'video'].includes(element.type)">
            <l-learning-admin-element-edit-content-form
                :initial-data="element"
                :disable-submit="disableSubmit"
                :show-delete-btn="showDeleteBtn"
                @deleteElement="deleteElement"
                @cancel="cancel"
                @submit="submit"
            />
        </div>
        <div v-else-if="element.type === 'task'">
            <l-learning-admin-element-edit-task-form
                :initial-data="element"
                :disable-submit="disableSubmit"
                :show-delete-btn="showDeleteBtn"
                @deleteElement="deleteElement"
                @cancel="cancel"
                @submit="submit"
            />
        </div>
        <div v-else-if="element.type === 'quiz'">
            <l-learning-admin-element-edit-quiz-form
                :initial-data="element"
                :disable-submit="disableSubmit"
                :show-delete-btn="showDeleteBtn"
                @deleteElement="deleteElement"
                @cancel="cancel"
                @submit="submit"
            />
        </div>
        <div v-else>
            <p>{{ $t("learning.admin.element.type.notRecognized", { type: element.type }) }}</p>
        </div>
    </div>
</template>

<script>
import LLearningAdminElementEditContentForm from "@/components/LLearningAdminElementEditContentForm";
import LLearningAdminElementEditQuizForm from "@/components/LLearningAdminElementEditQuizForm";
import LLearningAdminElementEditTaskForm from "@/components/LLearningAdminElementEditTaskForm";

export default {
    components: {
        LLearningAdminElementEditContentForm,
        LLearningAdminElementEditQuizForm,
        LLearningAdminElementEditTaskForm,
    },
    props: {
        element: {
            type: Object,
            required: true,
        },
        showDeleteBtn: {
            type: Boolean,
            default: true,
        },
        disableSubmit: {
            type: Boolean,
            required: true,
        },
        deleteElement: {
            type: Function,
            default: () => {},
        },
        cancel: {
            type: Function,
            required: true,
        },
        submit: {
            type: Function,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
